module.exports = __webpack_public_path__ + "static/media/TWELVE.f5c1fe15.png";